import { FC } from 'react';
import { Box, ThemeProvider } from '@mui/material';
import { DefaultTheme } from '../themes/default';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface ThemeContextProviderProps {
  children: React.ReactNode;
}

export const AppThemeProvider: FC<ThemeContextProviderProps> = ({
  children,
}) => {
  return (
    <ThemeProvider theme={DefaultTheme}>
      <Box>{children}</Box>
      <ToastContainer autoClose={3000} />
    </ThemeProvider>
  );
};
